export default "__VITE_ASSET__6c581f02__"